module.exports = __webpack_public_path__ + "img/News-Announcement-phone.cadfdd7c.png";